import React from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
import styled from "styled-components";

import BaseFormContainer from "../../common/components/form/BaseFormContainer";

import * as userActions from "../user.actions";
import { UserRoles } from "../user.constants";
import * as authActions from "../../auth/auth.actions";
import RegisterUserForm from "./RegisterUserForm";
import { ContentBlock } from "../../pages/components";
import Button from "../../../ui/button/Button";
import { Localize } from "../../../locale/localization";

const StyledTitle = styled.h2`
  margin-bottom: 2rem;
`;

const constraints = {
  firstName: {
    presence: {
      message: `^${Localize("form.register.firstname.error")}`
    }
  },
  lastName: {
    presence: {
      message: `^${Localize("form.register.lastname.error")}`
    }
  },
  address: {
    presence: {
      message: `^${Localize("form.register.address.error")}`
    }
  },
  zipcode: {
    length: {
      message: `^${Localize("form.register.zipcode.error")}`,
      is: 5
    },
    numericality: {
      onlyInteger: true,
      message: `^${Localize("form.register.zipcode.error")}`
    },
    presence: {
      message: `^${Localize("form.register.zipcode.error")}`
    }
  },
  city: {
    presence: {
      message: `^${Localize("form.register.city.error")}`
    }
  },
  password: {
    presence: {
      message: `^${Localize("form.register.password.error")}`
    }
  },
  passwordConfirm: {
    presence: {
      message: `^${Localize("form.register.password-confirm.error")}`
    },
    equality: {
      attribute: "password",
      message: `^${Localize("form.register.password-equality.error")}`
    }
  }
};

class RegisterUserFormContainer extends BaseFormContainer {
  constructor(props) {
    super(props);

    const formData = {
      firstName: "",
      lastName: "",
      address: "",
      zipcode: "",
      city: "",
      password: "",
      passwordConfirm: ""
    };

    this.state = {
      ...this.state,
      formData
    };
  }

  componentWillMount = () => {
    const { emailToken, validateEmailToken } = this.props;

    validateEmailToken(emailToken)
      .then(response => {
        console.log(response);
        this.setState({
          validatedToken: true,
          isValidToken: true,
          email: response.response.email,
          _id: response.response._id,
          authToken: response.response.authToken,
          team: response.response.team,
          region: response.response.region,
          channel: response.response.channel,
          role: response.response.role
        });
      })
      .catch(error => {
        console.log(error);
        this.setState({
          validatedToken: true,
          isValidToken: false,
          email: "",
          _id: null,
          authToken: null,
          team: null,
          region: null,
          channel: null,
          role: null
        });
      });
  };

  getConstraints = () => constraints;

  doSubmit = formData => {
    const { registerUser, loginUserToken, history } = this.props;

    const { authToken, team, region, channel, _id } = this.state;

    registerUser(authToken, {
      ...formData,
      team,
      region,
      channel,
      _id
    }).then(() => {
      loginUserToken(authToken).then(() => {
        history.replace("/");
      });
    });
  };

  render() {
    const { isValidToken, channel, region, team, role } = this.state;

    let title = "";
    switch (role) {
      case UserRoles.SALESMANAGER:
        title = `Rekisteröidy myyntikanavalle<br />${channel.name}`;
        break;
      case UserRoles.REGIONMANAGER:
        title = `Rekisteröidy alueelle<br />${region.name}`;
        break;
      case UserRoles.TEAMLEADER:
      case UserRoles.SELLER:
      case UserRoles.ASSISTANT:
        title = `Rekisteröidy tiimiin<br />${team.name}`;
        break;
      default:
    }

    return isValidToken ? (
      <ContentBlock>
        <StyledTitle dangerouslySetInnerHTML={{ __html: title }} />
        <RegisterUserForm
          enabled={!this.state.isSubmitting}
          onSubmit={this.onSubmit}
          onInputChange={this.onInputChange}
          onBlur={this.onBlur}
          errors={this.state.errors}
          touchedFields={this.state.touchedFields}
          isValid={this.state.isValid}
          email={this.state.email}
          firstName={this.state.formData.firstName}
          lastName={this.state.formData.lastName}
          address={this.state.formData.address}
          zipcode={this.state.formData.zipcode}
          city={this.state.formData.city}
          password={this.state.formData.password}
          passwordConfirm={this.state.formData.passwordConfirm}
        />
      </ContentBlock>
    ) : (
      <ContentBlock title="Virhe" center>
        <p>Virheellinen linkki.</p>
        <footer>
          <NavLink to="/" replace>
            <Button>Etusivulle</Button>
          </NavLink>
        </footer>
      </ContentBlock>
    );
  }
}

const mapStateToProps = (state, { match }) => {
  const { emailToken } = match.params;

  return {
    emailToken
  };
};

const ConnectedRegisterUserFormContainer = connect(
  mapStateToProps,
  Object.assign({}, userActions, authActions)
)(RegisterUserFormContainer);

export default withRouter(ConnectedRegisterUserFormContainer);



// WEBPACK FOOTER //
// ./src/modules/user/components/RegisterUserFormContainer.js